<template>
	<div class="mBrandLsCo">
		<div class="menuBox">
			<div class="menuImgBox" @click="open">
				<img class="menuImg" src="../../assets/mImg/menuIcon.png" alt="">
			</div>
			<div class="lansuImgBox">
				<img class="lansuImg" src="../../assets/logo2.png" alt="">
			</div>
			<!-- <div class="blackBox"></div> -->
		</div>
		<div class="firstBox">
			<img class="mFirst" src="../../assets/meiyeBdNew.jpg">
			<div class="busiz-mengban">
				<div class="login-container" v-show="isVideo" v-html="videoDetails">
				</div>
			</div>
		</div>

		<el-drawer class="drawerBox" :visible.sync="drawer" :direction="direction" :before-close="handleClose"
			unique-opened>
			<el-menu :default-active="this.$route.path" class="el-menu-vertical-demo" @open="handleOpen"
				@close="handleCloseMenu" router>
				<el-menu-item index="/m">
					<i class="el-icon-s-home"></i>
					<span slot="title">首页</span>
				</el-menu-item>
				<el-menu-item index="/maboutLansu">
					<i class="el-icon-document"></i>
					<span slot="title">关于我们</span>
				</el-menu-item>
				<el-menu-item index="/mbrandLansu">
					<i class="el-icon-data-analysis"></i>
					<span slot="title">美业菩提</span>
				</el-menu-item>
				<el-menu-item index="/mDynamicLanshu">
					<i class="el-icon-star-off"></i>
					<span slot="title">菩提基金会</span>
				</el-menu-item>
				<el-submenu index="5">
					<template slot="title">
						<i class="el-icon-trophy"></i>
						<span>兰树品牌</span>
					</template>
					<el-menu-item-group>
						<el-menu-item index="/mhuaibrand">淮树</el-menu-item>
						<el-menu-item index="/mxinbrand">心清堂</el-menu-item>
						<el-menu-item index="/mshuibrand">水姻缘</el-menu-item>
						<el-menu-item index="/myibrand">一清堂</el-menu-item>
						<!-- 	<el-menu-item index="/mzhongbrand"><span>Dr.CHUNG<span style="vertical-align: super;">+</span></span></el-menu-item> -->
						<el-menu-item index="/mlanshuBrand">兰树</el-menu-item>
						<el-menu-item index="/mzbqfBrand">植本清方</el-menu-item>
					</el-menu-item-group>
				</el-submenu>
				<el-menu-item index="/mTrends">
					<i class="el-icon-bell"></i>
					<span slot="title">兰树动态</span>
				</el-menu-item>
			</el-menu>

		</el-drawer>


		<div class="mhomeSecondBox">
			<div class="aboutTitle1">菩提节的诞生</div>
			<div class="aboutTitle2">The birth of Bodhi</div>
			<div class="birthBoxMain">
				<div class="imgItemBox1">
					<img class="puTiJieBoxImg" src="../../assets/aboutLanshu/putiItemNew1.jpg" alt="">
				</div>
				<div class="imgItemBox2">
					<img class="puTiJieBoxImg2" src="../../assets/aboutLanshu/putiItemNew2.jpg" alt="">
				</div>
				<div class="imgItemBox3">
					<img class="puTiJieBoxImg" src="../../assets/aboutLanshu/putiItemNew3.jpg" alt="">
				</div>
			</div>
			<div class="birthTitle">
				美容行业的从业人员肩负着发现美、传播美、分享美的使命。他们是美丽的使者，让更多的人变得美丽、自信、快乐。兰树为激发起美业人的自尊、自爱、自信，同时感恩他们对行业的热爱，对企业的敬畏，对顾客的尊重，因此设立了美业菩提节，这是为所有美容行业从业人员设立的专门节日。兰树企业于2016年成功举办了第一届美业菩提节，以后将每年举办一次。
			</div>
		</div>

		<div class="mThirdBox">
			<div class="mThirdMain">
				<div class="senseBoxHeader">

					<div class="iconTitle">菩提节的意义</div>
				</div>
				<el-carousel class="swiperItemBox" :interval="3000" height="80px" indicator-position="none"
					arrow="nerver">
					<el-carousel-item class="carouselBoxMain" v-for="(item,index) in yiyiData" :key="index">
						<div class="senseBoxText">
							{{item.text}}
						</div>
					</el-carousel-item>
				</el-carousel>
				<!-- <wc-swiper class="swiperItemBox">
				   <wc-slide class="swiperItemBoxSlide" v-for="(item,index) in yiyiData" :key="index" >
						 <div class="senseBoxText">
							 {{item.text}}
						 </div>
				   </wc-slide>
				</wc-swiper> -->
				<div class="senseBoxLine"></div>
				<div class="senseTitleBox">
					<div class="senseTitle1">兰树创始人</div>
					<!-- <div class="senseTitle2">钟鸣</div> -->
					<img class="signBox" src="../../assets/brandLanshu/zhong_name.png" alt="">
				</div>
			</div>
		</div>


		<div class="mforthBox">
			<div class="forthBox">
				<!-- <img class="mforthBoxImg" src="../../assets/putizhige.png" alt=""> -->
				<div class="busiz-mengbanForth">
					<div class="login-container" v-show="isVideo2" v-html="videoDetails2">
					</div>
				</div>
			</div>
		</div>

		<div class="mfifthBox">
			<div class="aboutTitle1">菩提节的成就</div>
			<div class="aboutTitle2">ACHIEVEMENTS OF BODHI FESTIVAL</div>
			<wc-swiper class="swiperItemBoxAc">
				<wc-slide v-for="(item,index) in achievementData" :key="index" :class="styleData[index]">
					<div class="swiperBoxMain2">
						<img class="cultureBoxImg" :src="item.img" alt="">
						<div class="achievementT1">{{item.title1}}</div>
						<div class="achievementT2">{{item.title2}}</div>
					</div>
				</wc-slide>
			</wc-swiper>
		</div>

		<div class="msixthBox">
			<div class="aboutTitle1">菩提节 · 盛典</div>
			<div class="aboutTitle2">BODHI FESTIVAL</div>
			<div class="putijieBoxMain" @click="enterPuti(item.id,item.video_url)" v-for="(item,index) in puTiJIeData"
				:key="index">

				<div class="putijieBoxMainItem">
					<img class="putijieBoxMainItemImg" :src="item.thumbnail_url" alt="">
					<div class="putijieItemTitle busiz-text-ellipes">{{item.title}}</div>

				</div>
				<div class="lineHeight"></div>
			</div>
		</div>

		<div class="msixthBox">
			<div class="aboutTitle1">菩提节 · 风采</div>
			<div class="aboutTitle2">BODHI FESTIVAL STYLE</div>
			<div class="putijieBoxMain" @click="enterMedia(item.id)" v-for="(item,index) in newsData" :key="index">

				<div class="putijieBoxMainItem">
					<img class="putijieBoxMainItemImg" :src="item.thumbnail_url" alt="">
					<div class="putijieItemTitle busiz-text-ellipes">{{item.title}}</div>

				</div>
				<div class="lineHeight"></div>

				<!-- <div class="newsItem">
					<div class="dyNewMainBoxItemImg">
						<img class="dyNewImg" :src="item.thumbnail_url" alt="">
					</div>
					<div class="dyNewsContent">
						<div class="dyNewsContentTitle busiz-text-ellipes1">{{item.title}}</div>
					</div>
				</div>
				<div class="lineHeight"></div> -->
			</div>
		</div>

		<div class="footerBoxMain">
			<div class="footerBoxMainMiddle">
				<div class="footerBoxTitle">快捷导航</div>
				<div class="bottomNavFirst bottomNav1">
					<div class="mHomeName">
						<router-link to="/m" tag="a">首页</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mDynamicLanshu" tag="a">菩提基金会</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav2">
					<div class="mHomeName">
						<router-link to="/maboutLansu" tag="a">关于兰树</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mhuaibrand" tag="a">兰树品牌</router-link>
					</div>
				</div>
				<div class="bottomNavFirst bottomNav3">
					<div class="mHomeName">
						<router-link to="/mbrandLansu" tag="a">美业菩提</router-link>
					</div>
					<div class="ptjjhName">
						<router-link to="/mTrends" tag="a">兰树动态</router-link>
					</div>
				</div>
				<div class="footerBoxTitle footerBoxTitle2">联系我们</div>
				<div class="contactFirst contactFirst1">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/emailIcon.png" alt="">
					</div>
					<div class="contactContent">
						邮箱：postermaster@lasur.com
					</div>
				</div>
				<div class="contactFirst contactFirst2">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/phoneIcon.png" alt="">
					</div>
					<div class="contactContent">
						电话：0571-89025888
					</div>
				</div>
				<div class="contactFirst contactFirst3">
					<div class="contactImgBox">
						<img class="contactImg" src="../../assets/mImg/gpsIcon.png" alt="">
					</div>
					<div class="contactContent">
						浙江省杭州市之江东路越秀·维多利中心A座 17楼
					</div>
				</div>
			</div>
			<div class="bottomLine"></div>
			<div class="codeBoxMain">
				<div class="footerBoxHeaderLeft">
					<img class="codeImg" src="../../assets/code.png" alt="">
					<span class="codeText">兰树公众号</span>
				</div>
				<div class="footerBoxHeaderRight">
					<img class="codeImg" src="../../assets/xcxNew.jpg" alt="">
					<span class="codeText">兰树云小程序</span>
				</div>
			</div>
			<div class="footerBoxBottom">
				<div class="footerLeft">
					Copyright © 2023 兰树化妆品股份有限公司
				</div>
				<div class="footerLeft">
					<a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index">浙ICP备20018890号-1</a><br />
					<img
						src="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2022-09-13_13-29-23_21054.png" /><a
						target="_blank"
						href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33052102000740">浙公网安备
						33052102000740号</a>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import { myGet, myPost, login } from "../../api/http.js";
export default {
	data() {
		return {
			drawer: false,
			direction: 'ltr',
			yiyiData: [
				{
					id: 1,
					text: '传播美：为美业人搭建专业的培训及交流平台，致力于将美容师培养成美容医师，用专业的服务为更多消费者带去美好容颜。'
				},
				{
					id: 2,
					text: '奉献爱：建立「菩提基金会」，以感恩之心回馈社会，助力公益事业，为社会带去更多温暖，让世界因我们而更美好。'
				},
				{
					id: 3,
					text: '圆梦想：为美业人打造圆梦平台，提供发展机会，激发美业人的逐梦之心，和全体美业人一起逐梦未来。'
				}
			],
			styleData: [
				"first",
				"second",
				"third"
			],
			achievementData: [
				{
					id: 1,
					img: require('../../assets/brandLanshu/first.png'),
					title1: '传播美',
					title2: '用更好的产品，更专业的服务，为爱美人士带去健康美丽的肌肤'
				},
				{
					id: 2,
					img: require('../../assets/brandLanshu/second.png'),
					title1: '奉献爱',
					title2: '建立“菩提基金会”，捐助“大拇指工程”，让更多患病儿童获得救助，竖起大拇指。疫情期间，第一时间向湖北省红十字会捐款50万元'
				},
				{
					id: 3,
					img: require('../../assets/brandLanshu/third.png'),
					title1: '圆梦想',
					title2: '开展“寻找圆梦人”活动，代理商打造圆梦平台，加盟商许愿，齐心协力，撸起袖子加油干，一起逐梦未来'
				}
			],
			isBanner: true,// 是否显示banner图
			isVideo: false,// 是否显示视频
			isBanner2: true,// 是否显示banner图
			isVideo2: false,// 是否显示视频
			puTiJIeData: [],
			newsData:[]
		}
	},
	created() {
		this.gitSecurity();
		this.initVideo();
		this.initVideoSecond();
		this.gitSecurity1();
	},
	methods: {
		enterMedia(id) {
			this.$router.push({ path: '/mNewsDetail', query: { userId: id } });
		},
		//获取菩提风采
		gitSecurity1() {
			// 0.兰树新闻 1.媒体聚焦 2.视频咨询
			myPost("api/messageslist/", {
				newtype: 0,
				pageNum: 1,
				pageSize: 6
			}).then((res) => {
				this.newsData = res.data.news_list;
				this.total = res.data.total_num;
			});
		},
		//获取兰树新闻
		gitSecurity() {
			// 0.兰树新闻 1.媒体聚焦 2.视频咨询
			myPost("api/messageslist/", {
				newtype: 3,
				pageNum: 1,
				pageSize: 12
			}).then((res) => {
				this.puTiJIeData = res.data.news_list;
				this.total = res.data.total_num;
			});
		},
		enterPuti(id, videoUrl) {
			this.$router.push({ path: '/mPutiDetail', query: { userId: id, videoUrl: videoUrl } });
		},
		// 视频
		initVideo() {
			this.videoDetails = `<video
				 							  id="onemyVideo"
				 							  class="video-js vjs-big-play-centered vjs-fluid"
				 							  controls
				 							  preload="auto"
				 							  width="100%"
				 							  height="100%"
				 							  poster=""
				 							>
				 								<source
			           type="application/x-mpegURL"
			           src="https://www.lasur.com/media/beauty/video/2020/12/10/strength2.m3u8"
			          >
				 							</video>`
			//此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
			//页面dom元素渲染完毕，执行回调里面的方法
			//请求视频资源后关闭	 Banner
			setTimeout(() => {
				this.isBanner = false;

				this.isVideo = true;
			}, 2000)
			this.$nextTick(() => {
				let myPlayer = this.$video(document.getElementById('onemyVideo'), {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					muted: false,
					//自动播放属性,muted:静音播放
					autoplay: true,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					loop: true,
					//设置视频播放器的显示宽度（以像素为单位）
					// width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					// height: "400px",
					controlBar: {
						playToggle: true
					}
				});
			});

		},
		initVideoSecond() {
			this.videoDetails2 = `<video
				 	 							  id="secondmyVideo"
				 	 							  class="video-js vjs-big-play-centered vjs-fluid"
				 	 							  controls
				 	 							  preload="auto"
				 	 							  width="100%"
				 	 							  height="100%"
				 	 							  poster="https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2021-03-26_11-24-04_54177.jpg"
				 	 							>
				 	 								<source
				            type="application/x-mpegURL"
				            src="https://www.lasur.com/media/beauty/video/2021/03/01/mengxiangdeliliang.m3u8"
				           >
				 	 							</video>`
			//此处初始化的调用，我放在了获取数据之后的方法内，而不是放在钩子函数mounted
			//页面dom元素渲染完毕，执行回调里面的方法
			//请求视频资源后关闭	 Banner
			setTimeout(() => {
				this.isBanner2 = false;

				this.isVideo2 = true;
			}, 2000)
			this.$nextTick(() => {
				let myPlayer = this.$video(document.getElementById('secondmyVideo'), {
					//确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
					controls: true,
					muted: false,
					//自动播放属性,muted:静音播放
					autoplay: false,
					//建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
					preload: "auto",
					loop: true,
					//设置视频播放器的显示宽度（以像素为单位）
					// width: "800px",
					//设置视频播放器的显示高度（以像素为单位）
					// height: "400px",
					controlBar: {
						playToggle: true
					}
				});
			});

		},
		handleClose(done) {
			done()
		},
		open() {
			this.drawer = true
		},
		handleOpen(key, keyPath) {
			console.log(key, keyPath);
		},
		handleCloseMenu(key, keyPath) {
			console.log(key, keyPath);
		}
	}
}
</script>

<style scoped>
.mBrandLsCo {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.mFirst {
	width: 100%;
}

.mThird {
	width: 100%;
	position: absolute;
}

.mhomeSecondBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F4F5F5;
	/* padding-bottom:10rem; */
	padding-bottom: 2rem;
}

.aboutTitle1 {
	font-size: 2.25rem;
	color: #000000;
	margin-top: 1rem;
	line-height: 50px;
}

.aboutTitle2 {
	font-size: 1.25rem;
	color: #888888;
}

.birthBoxMain {
	width: 95%;
	display: flex;
	flex-direction: row;
	justify-content: space-around;
	margin-top: 1rem;
}

.imgItemBox1 {
	width: 25%;
}

.imgItemBox2 {
	width: 40%;
}

.imgItemBox3 {
	width: 23%;
}

.puTiJieBoxImg {
	width: 100%;
}

.puTiJieBoxImg2 {
	width: 100%;
}

.birthTitle {
	width: 90%;
	font-size: 0.9rem;
	color: #333333;
	margin-top: 1rem;
	line-height: 20px;
}

.mThirdBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	background: url(https://yuyange-prod.oss-cn-hangzhou.aliyuncs.com/miniapp/2023-08-18_10-23-26_24112.png) no-repeat;
	background-size: 100%;
}


.mThirdMain {
	width: 90%;
	display: flex;
	flex-direction: column;
	position: relative;
	padding-top: 8%;
	padding-bottom: 6%;
}



.senseBoxHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	margin-top: 0.5rem;
}

.douIcon {
	width: 1rem;
}


.iconTitle {
	font-size: 1.1rem;
	font-family: MicrosoftYaHei;
	color: #FFFFFF;
	line-height: 35px;
}

.senseBoxText {
	width: 80%;
	display: flex;
	font-size: 0.7rem;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.8;
	/* box-sizing: border-box; */
}

.senseBoxLine {
	width: 53%;
	height: 2px;
	background-color: #FFFFFF;
	opacity: 0.2;
	display: flex;
	margin-bottom: 1rem;
}

.senseTitle1 {
	font-size: 1.125em;
	font-family: MicrosoftYaHei;
	color: #FFFFFF;
	line-height: 24px;
	display: flex;
}

.signBox {
	width: 3rem;
	position: relative;
	left: 25%;
	margin-top: -1rem;
	/* animation: puTiAnimate1 3s;
		-webkit-animation: puTiAnimate1 3s; */
}

.senseTitleBox {
	display: flex;
	flex-direction: column;
	font-size: 0.8rem;
}

.swiperItemBox {
	width: 80%;
}

.mforthBox {
	width: 100%;
	flex-direction: column;
	display: flex;
	align-items: center;
	background-color: #FFF;
}

.mforthBoxImg {
	width: 100%;
}

.mfifthBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #F4F5F5;
	/* padding-bottom:10rem; */
	padding-bottom: 2rem;
}

.swiperBoxMain {
	width: 80%;
	/* padding-bottom: 2rem; */
	height: 350px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.swiperBoxMain2 {
	width: 100%;
	/* padding-bottom: 2rem; */
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	padding-bottom: 1rem;
}

.swiperBoxMainImg {
	width: 100%;
}

.swiperBoxMainTitle1 {
	font-size: 1.5rem;
	color: #000000;
	margin-top: 1rem;
}

.swiperBoxMainTitle2 {
	color: #666666;
	font-size: 1rem;
}

.achievementT1 {
	color: #222222;
	font-size: 1.1rem;
	margin-top: 1rem;
}

.achievementT2 {
	color: #666666;
	font-size: 1rem;
	text-align: center;
	width: 80%;
	margin-top: 0.5rem;
	padding-bottom: 1rem;
}

.first .cultureBoxImg {
	width: 8rem;
}

.second .cultureBoxImg {
	width: 8rem;
}

.third .cultureBoxImg {
	width: 8rem;
}

.cultureBoxImg {
	margin-top: 1rem;
}

.msixthBox {
	width: 100%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	background-color: #FFFFFF;
	/* padding-bottom:10rem; */
	padding-bottom: 2rem;
}

.putijieBoxMain {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

.putijieBoxMainItem {
	width: 80%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin: 0 auto;
	margin-top: 1rem;
}

.putijieBoxMainItemImg {
	width: 100%;
	border-radius: 1rem;
}

.busiz-text-ellipes {
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 1;
	/*! autoprefixer: off */
	-webkit-box-orient: vertical;
	/*autoprefixer: on */
}

.putijieItemTitle {
	margin-top: 1rem;
	color: #000000;
	font-size: 1rem;
}


.footerFirstLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 1rem;
}

.footerSecondLine {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	margin: 0 auto;
	justify-content: center;
	margin-top: 0.5rem;
}

.footerItem {
	list-style: none;
}

.footerItem a {
	color: #333333;
	font-size: 0.9375rem;
	text-decoration: none;
	margin-left: 0.5rem;
}

.lastHeader {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	font-size: 0.9375em;
	font-weight: 400;
	color: #666666;
	line-height: 28px;
	margin-left: 1rem;
}

.lastHeader li a {
	text-decoration: none;
	font-size: 0.9375rm;
	font-weight: 400;
	color: #222222;
	line-height: 28px;
}

.lastHeader li {
	list-style: none;
}

.footerBoxHeader {
	width: 60%;
	margin: 0 auto;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-top: 1rem;
}

.footerBoxHeaderLeft,
.footerBoxHeaderRight {
	display: -ms-flexbox;
	display: flex;
	-ms-flex-direction: column;
	flex-direction: column;
	-ms-flex-align: center;
	align-items: center;
}


.footerInfoBox {
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 1rem;
}

.emailBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
}


.phoneBox {
	font-size: 0.875rem;

	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
}

.addressBox {
	font-size: 0.875rem;
	font-weight: 400;
	color: #222222;
	line-height: 20px;
	margin-top: 0.5rem;
	text-align: center;
}

.footerLine {
	width: 100%;
	height: 1px;
	display: flex;
	background: #000000;
	opacity: 0.1;
	margin: 0 auto;
	align-items: center;
	margin-top: 0.5rem;
}

.footerBoxBottom {
	display: flex;
	margin: 0 auto;
	align-items: center;
	flex-direction: column;
	justify-content: center;
	margin-top: 1rem;
}




.mFirst {
	width: 100%;
}

.mFirstBox {
	position: absolute;
	top: 0;
	z-index: 99;
	left: 0;
}



.mFirstBoxImgBox {
	width: 100%;
	margin-top: 0.5rem;
}

.mFirstBoxImg {
	width: 50%;
	float: left;
	position: relative;
	left: 0.5rem;
}

.firstBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 3.5rem;
}

.forthBox {
	width: 100%;
	display: flex;
	flex-direction: column;
	align-items: center;
}

/* 视频组件 */
.busiz-mengban {
	width: 100%;
	height: 100%;
	position: absolute;
	top: 3.5rem;
	z-index: 1;
}

.login-container {
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	box-sizing: border-box;
	background-size: cover;
}


.busiz-mengbanForth {
	width: 100%;
	height: 100%;
	z-index: 1;
}

.lineHeight {
	width: 100%;
	height: 0.6rem;
	background-color: #F4F5F5;
	margin-top: 1rem;
}

.footerBoxMainMiddle {
	width: 80%;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	margin-top: 1.5rem;
}

.footerBoxTitle {
	color: #FFFFFF;
	font-size: 1rem;
	font-weight: 500;
}

.bottomNavFirst {
	width: 100%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin-top: 1rem;
}

.mHomeName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.ptjjhName a {
	color: #FFFFFF;
	opacity: 0.6;
	font-size: 0.9rem;
	text-decoration: none;
}

.contactFirst {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.contactImgBox {
	width: 0.8rem;
}

.contactImg {
	width: 100%;
}

.contactContent {
	color: #FFFFFF;
	font-size: 0.7rem;
	opacity: 0.7;
	margin-left: 0.5rem;
}

.bottomLine {
	width: 100%;
	height: 2px;
	background: #FFFFFF;
	opacity: 0.1;
	margin-top: 1.5rem;
}

.footerBoxTitle2 {
	margin-top: 1.5rem;
}

.contactFirst1 {
	margin-top: 1rem;
}

.codeBoxMain {
	width: 50%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	margin: 0 auto;
	margin-top: 1.5rem;
}


.codeImg {
	width: 80%;
}

.codeText {
	font-size: 0.5em;
	color: #FFFFFF;
	line-height: 20px;
	opacity: 0.7;
	/* margin-top: 0em; */
}

.footerBoxMain {
	width: 100%;
	background-color:  #2c5eff;
	display: flex;
	flex-direction: column;
	align-items: center;
	margin-top: 2rem;
	padding-bottom: 1rem;
}

.footerLeft {
	text-align: center;
	font-size: 0.9em;
	color: #FFFFFF;
	line-height: 24px;
	opacity: 0.7;
}

.footerLeft a {
	text-decoration: none;
	cursor: pointer;
	color: #FFFFFF;
	opacity: 0.7;
}

.contactFirst2 {
	margin-top: 0.5rem;
}

.contactFirst3 {
	margin-top: 0.5rem;
}

/* 新导航栏 */
.menuBox {
	position: fixed;
	width: 100%;
	display: flex;
	top: 0;
	flex-direction: row;
	background: #FFFFFF;
	padding-top: 0.8rem;
	padding-bottom: 0.5rem;
	align-items: center;
	justify-content: space-between;
	z-index: 999;
}

.menuImgBox {
	width: 33.33%;
}

.menuImg {
	width: 17%;
	margin-left: 1rem;
}

.lansuImgBox {
	width: 40%;
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: center;
	margin-right: 1rem;
}

.blackBox {
	width: 33.33%;

}

.lansuImg {
	width: 100%;
}



</style>



// WEBPACK FOOTER //
// src/components/mComponents/mBrandLansu.vue